import {
    Index,
    ParadeState,
    CurrentParadeState,
    ParadeStateDate,
    ParadeHeld,
    CompanyAbsent,
    AttCompanyPresent,
    ParadeStateDetails,
    CompanyAbsentDetails,
    ParadeStateAbsent,
    Dashboard,
} from "../Components/index.js";

export default [
    {
        path: "/dashboard/duty",
        component: Dashboard,
        name: "report-parade-dashboard",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/parade-state-absent",
        component: ParadeStateAbsent,
        name: "report-parade-state-absent",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company-parade-state-absent-details",
        component: CompanyAbsentDetails,
        name: "report-company-absent-details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company-parade-state",
        component: () => import("../Components/Company/daily_parade_state.vue"),
        name: "report.master.parade.state",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company-parade-state-current",
        component: CurrentParadeState,
        name: "report.master.parade.state.current",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company-parade-state-date",
        component: ParadeStateDate,
        name: "report.daily.cadre.parade.state",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company-present/:companyId?",
        component: () => import("../Components/Company/company_present.vue"),
        name: "report.company.present",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company-date-parade",
        component: () => import("../Components/Company/company_date_parade.vue"),
        name: "report-company-date-parade",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/attach-company-present/:company_id?",
        component: AttCompanyPresent,
        name: "report.attach.company.present",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company-absent/:companyId",
        component: CompanyAbsent,
        name: "report.company.absent",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company-absent-all",
        component: CompanyAbsent,
        name: "report.company.absent.all",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/company-parade-held",
        component: ParadeHeld,
        name: "company.parade.held",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company",
        component: Index,
        name: "company",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/parade-state",
        component: ParadeState,
        name: "report.parade.state",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/parade-state/:id",
        component: ParadeStateDetails,
        name: "report.parade.state.details",
        meta: {
            requiresAuth: true,
        },
    },
];
